// extracted by mini-css-extract-plugin
export default {"NavBarBrand":"Logo_NavBarBrand__efHK7"};